module.exports = __webpack_public_path__ + "files/f21d3bce72bfcb21ad58d2cad9e8a9bd.png";